/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TUpdateTitleSavedSearchDesktopRequest,
  TUpdateTitleSavedSearchDesktopModel,
  IMappers,
  TUpdateTitleSavedSearchDesktopResponse,
  TUpdateTitleSavedSearchDesktopResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUpdateTitleSavedSearchDesktopModel(
  parameters: TUpdateTitleSavedSearchDesktopRequest,
): TUpdateTitleSavedSearchDesktopModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'saved-searches',
    pathApi: '/v1/update-title-saved-search-desktop/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IUpdateTitleSavedSearchDesktopOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateTitleSavedSearchDesktopRequest;
}

export async function fetchUpdateTitleSavedSearchDesktop<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateTitleSavedSearchDesktopOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUpdateTitleSavedSearchDesktopResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUpdateTitleSavedSearchDesktopModel(parameters),
    config,
  )) as FetchResponse<TUpdateTitleSavedSearchDesktopResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUpdateTitleSavedSearchDesktopResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUpdateTitleSavedSearchDesktopResponse>;
}
